import { TimeCard } from '../../../Common/Charts/TimeCard/TimeCard';
import { useCallsChartsDataContext } from './hooks/useCallsChartsDataContext';

export const CallsTimes = () => {
    const { chartData } = useCallsChartsDataContext();
    const times = chartData?.callsTimes;

    return (
        <div className="charts-side-by-side-dashboards">
            <TimeCard title="Chamado - Tempo Mínimo" value={times?.minTime} />
            <TimeCard title="Chamado - Tempo Médio" value={times?.avgTime} />
            <TimeCard title="Chamado - Tempo Máximo" value={times?.maxTime} />
        </div>
    );
};
